<template>
  <p class="p-3 text-center">
  </p>
</template>

<script>
export default {
  // name: "FooterPartial",
};
</script>